// Question Population and Search
const questionArray = [
  {
    "question": "What are the best methods for thawing my products?",
    "answer": "For best results, thaw in the refrigerator. You can thaw meat and poultry in packaging, but remove seafood from packaging. For quick thawing, submerge vacuum-sealed items in cold water for 30–45 minutes. Avoid microwaves—they dry out the product. Only microwave-thaw if cooking immediately."
  },
  {
    "question": "Can I use a business address or PO Box for my delivery address?",
    "answer": "We deliver to residential and business addresses, but not to PO Boxes or military bases. UPS deliveries may arrive after normal business hours."
  },
  {
    "question": "When will my package ship?",
    "answer": "Orders ship within 5 business days. You’ll receive a shipping confirmation and tracking number from UPS once it ships."
  },
  {
    "question": "Where do you ship?",
    "answer": "We ship within the continental U.S. only. We cannot ship to Hawaii, Alaska, Canada, or military bases."
  },
  {
    "question": "Do you charge for shipping?",
    "answer": "Our shipping is FREE on all orders over $199, and $19.99 for all other purchases."
  },
  {
    "question": "What if I have an existing subscription?",
    "answer": "If you already have a subscription, no worries—you’ll continue receiving your order just like before. You can also cancel at any time from your account."
  },
  {
    "question": "Where do your products come from?",
    "answer": "From trusted farmers we've worked with for over 40 years. Contact us with specific questions."
  },
  {
    "question": "My box arrived with melted dry ice, is it still safe to eat?",
    "answer": "Check internal temperature. If items are cool or below 40°F, they’re safe to refreeze or cook."
  },
  {
    "question": "How long do my products last in the fridge once thawed?",
    "answer": "Meats last 5–7 days, seafood 3–5 days in the fridge. In the freezer, they last up to 12 months."
  },
  {
    "question": "What payment types are accepted? When will my card be charged?",
    "answer": "We accept all major credit cards and PayPal, Apple Pay, Google Pay, Amazon Pay. You’ll see a charge when we prepare your shipment."
  },
  {
    "question": "What is the option to pay in installments on Shop Pay?",
    "answer": "Split your purchase into 4 equal biweekly payments with 0% interest, no fees, and no credit impact."
  },
  {
    "question": "Which payment methods are accepted for Shop Pay installments?",
    "answer": "Both debit and credit cards."
  },
  {
    "question": "What if I make a return on a Shop Pay installment purchase?",
    "answer": "Refunds go to your original payment method within 3–10 business days. It may reduce future payments or shorten your plan."
  },
];

// Function to generate question and answer elements
function createQuestionAndAnswerElements(item) {
    const questionElem = document.createElement('div');
    questionElem.classList.add('question');
    questionElem.innerHTML = `${item.question}<button class="expand-icon">+</button>`;

    const answerElem = document.createElement('div');
    answerElem.classList.add('answer');
    answerElem.textContent = item.answer;

    const dividerLine = document.createElement('span');
    dividerLine.classList.add('divider-line-flat');

    return [questionElem, answerElem, dividerLine];
}

// Function to attach event listeners for expanding questions
function attachEventListeners(questions) {
    questions.forEach(question => {
        question.addEventListener('click', function() {
            const answer = this.nextElementSibling;

            if (answer.classList.contains('expanded')) {
                answer.classList.remove('expanded');
                this.querySelector('.expand-icon').innerText = '+';
            } else {
                answer.classList.add('expanded');
                this.querySelector('.expand-icon').innerText = '-';
            }
        });
    });
}

// Question Population
const questionContainer = document.getElementById('faq-container');
let questions = [];

function populateQuestions() {
    questionArray.forEach(item => {
        const [questionElem, answerElem, dividerLine] = createQuestionAndAnswerElements(item);

        questions.push(questionElem);
        questions.push(answerElem);
        questions.push(dividerLine);
    });

    questionContainer.innerHTML = '';
    questions.forEach(q => questionContainer.appendChild(q));

    // Attach event listeners for expanding questions
    attachEventListeners(document.querySelectorAll('.question'));
}

populateQuestions();

// Search functionality
const searchInput = document.getElementById('search-input');
searchInput.addEventListener('input', searchQuestions);

function searchQuestions() {
    const keyword = searchInput.value.trim().toLowerCase();
    const filteredQuestions = questionArray.filter(item => {
        return item.question.toLowerCase().includes(keyword) || item.answer.toLowerCase().includes(keyword);
    });

    questions = [];
    filteredQuestions.forEach(item => {
        const [questionElem, answerElem, dividerLine] = createQuestionAndAnswerElements(item);

        questions.push(questionElem);
        questions.push(answerElem);
        questions.push(dividerLine);
    });

    questionContainer.innerHTML = '';
    questions.forEach(q => questionContainer.appendChild(q));

    // Attach event listeners for expanding questions
    attachEventListeners(document.querySelectorAll('.question'));
}
